/**
 * Extracted from sections/ns-tabbed-videos.liquid (inline <script> at line 313).
 * Config bridge: window.__nsTabbedVideosSections, keyed by section id — the inline block
 * only needed Liquid for the section id, so the id is now handed over as
 * data and the logic runs from a cacheable, deferred asset instead of
 * being parsed and compiled during the HTML parse (INP work on the PDP).
 * Boots once per section id so multiple instances still each initialise.
 */

(function () {
  var cfg = window.__nsTabbedVideosSections = window.__nsTabbedVideosSections || {};
  function boot(sectionId, settings) {
  function tabbedVideosLayout () {
    let section = document.querySelector(`#shopify-section-${sectionId}`)
  
    // active/deactive tab/gallery
    const videoTabAllEls = section.querySelectorAll('.ns-tabbed-videos__tab-single');
    const videoContentAllEls = section.querySelectorAll('.ns-tabbed-videos__video-container');

    function activatevideoTab(videoTab) {
      let clickedIndex = videoTab.getAttribute('data-ns-video-tab-index');
    
      videoTabAllEls.forEach(el => el.classList.remove('active'));
      videoTabAllEls[clickedIndex].classList.add('active');

      videoContentAllEls.forEach(el => el.classList.remove('active'));
      videoContentAllEls[clickedIndex].classList.add('active');
      videoContentAllEls.forEach(el => {
        if (el.classList.contains('active') == false && el.querySelector('iframe')) {
          let videoIframe = el.querySelector('iframe')
          if (videoIframe) {
            let videoIframeSrc = videoIframe.src;
            videoIframe.src = videoIframeSrc;
          }
        }
        if (el.classList.contains('active') == false && el.querySelector('video-media')) {
          let video = el.querySelector('video')
          if (video) {
            console.log('pause');
            video.pause();
          }
        }
      });
    }

    videoTabAllEls.forEach(videoTab => {
      videoTab.addEventListener('click', () => {
        activatevideoTab(videoTab)
      });
    });

    if(videoTabAllEls.length > 0) activatevideoTab(videoTabAllEls[0]);
 
  }
  
  tabbedVideosLayout()
  
  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      tabbedVideosLayout()
    });
  }
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
